import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import DataMapperBulkExportStore, { DATA_MAPPER_BULK_EXPORT_ROUTE } from "./DataMapperBulkExportStore";

const bulkExportStore = (rootStore: RootStore) =>
  (rootStore as unknown as { dataMapperBulkExportViewStore?: DataMapperBulkExportStore }).dataMapperBulkExportViewStore;

/**
 * Data Mapper → Bulk Export: every mapped Titan table, exported from this tab's
 * source into one zip the requester downloads (HQ deletes it once downloaded or expired).
 *
 * The wizard's stepper offers this step only while the open profile is marked
 * as a Titan profile (wizard/wizardSteps.ts). That is UI gating; the API
 * refuses every Bulk Export action for a non-Titan profile, and the screen
 * says so if the URL is typed.
 */
const dataMapperBulkExportRoute: RouteType[] = [
  {
    name: DATA_MAPPER_BULK_EXPORT_ROUTE,
    path: "/data-mapper/bulk-export",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Bulk Export",
        enableRefreshButton: true,
        component: () => import("./DataMapperBulkExport.Header"),
      },
      body: {
        component: () => import("./DataMapperBulkExport.Body"),
        grayBackground: true,
      },
    },
    group: "Data Mapper",
    searchAliases: ["titan bulk export", "bulk export", "titan export", "export titan tables"],
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      void bulkExportStore(rootStore)?.enter();
    },
    onExit: ({ rootStore }) => {
      bulkExportStore(rootStore)?.reset();
    },
  },
];

export default dataMapperBulkExportRoute;
